import { forwardRef } from "react";

import { Form } from "@shared/components/Form";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getPromocodeBatchesService } from "@modules/promocodeBatches/services/queries/listPromocodeBatches/service";

export const PromocodeBatchesAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      queryHook={getPromocodeBatchesService}
    />
  );
});

PromocodeBatchesAutocomplete.displayName = "PromocodeBatchesAutocomplete";
